const regExp = /^ORA-\d+:\s*(.*?)\s*ORA-/

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { getErrorMessage } from "~/shared/lib/utils"

/** В некоторых api сообщение об ошибке приходит из PL/SQL вместе с лишней информацией.
 * Эта утилита извлекает только нужное сообщение.
 * Используется внутри утилиты {@link getErrorMessage}, которую рекомендуется использовать при обработке ошибок, возвращенных api
 */
export function extractOracleErrorMessage(error: string) {

	const parsed = regExp.exec(error)

	if (!parsed) return error

	return parsed[1]
}